/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationResponse, UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteResetGroupPermissions";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteResetGroupPermissions } from "../axios/usersAuthzAPIAdminPermissionsWriteResetGroupPermissions";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationKey = () => ["users-authz-api", { url: '/admin/group/:groupId/permissions/reset' }] as const

export type UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationKey>

/**
 * @summary Reset all permissions for a group
 * {@link /admin/group/:groupId/permissions/reset}
 */
export function useUsersAuthzAPIAdminPermissionsWriteResetGroupPermissions<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationResponse, ResponseErrorConfig<Error>, {groupId: UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsPathParams["groupId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsMutationResponse, ResponseErrorConfig<Error>, {groupId: UsersAuthzAPIAdminPermissionsWriteResetGroupPermissionsPathParams["groupId"]}, TContext>({
    mutationFn: async({ groupId }) => {
      return usersAuthzAPIAdminPermissionsWriteResetGroupPermissions(groupId, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}